"use client"

import { useAppSelector } from "@/lib/redux/hooks"
import { useMemo } from "react"

export const useIsRoundAway = () => {
  const inputFlights = useAppSelector(state => state.flight.inputFlights)
  return useMemo(() => {
    return inputFlights.some(input => input.isReturn)
  }, [inputFlights])
}